import { render, staticRenderFns } from "./TgNoMatch.vue?vue&type=template&id=5415377c&"
import script from "./TgNoMatch.vue?vue&type=script&lang=js&"
export * from "./TgNoMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports